import { createSlice } from '@reduxjs/toolkit'

const initialState = {
   footerShow: true,
}

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setFooterShow: (state, action) => {
      state.footerShow = action.payload
    }
  },
})

export const { setFooterShow } = layoutSlice.actions
export default layoutSlice.reducer
